import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { editProfile } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { UserProvider, UserConsumer } from '../../../../UserContext'
import UserEditProfileContent from '../../../../components/EditProfile/UserEditProfileContent'
import { FormLoader } from '../../../../components/Loader/FormLoader'


const UserEditProfile = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.UserProfileEdit' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editProfile.image}
               description={intl.formatMessage({ id: 'PageTitle.UserProfileEdit' })}
          />
          <AuthenticatedUserConsumer>
            {({ getRoles, roles, getCountries, getGovernments, governments, getCities, cities, userDataLoading, userData, adminSectionType, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <UserProvider uid={id} adminSectionType={adminSectionType}
                                  handleNotificationCall={handleNotificationCall}>
                      <UserConsumer>
                        {({ getSelectedUserData }) => (
                          <UserEditProfileContent getCountries={getCountries}
                                                  getRoles={getRoles}
                                                  getGovernments={getGovernments}
                                                  governments={governments}
                                                  getCities={getCities}
                                                  cities={cities}
                                                  roles={roles}
                                                  adminSectionType={adminSectionType}
                                                  getSelectedUserData={getSelectedUserData}/>
                        )}
                      </UserConsumer>
                    </UserProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.home}/>
      }
    </>
  )
}

export default UserEditProfile

